import {ProviderProps} from "../types/providerProps";
import {useBrowserHistoryNavigation} from "../initialization/useBrowserHistoryNavigation";
import {useGlobalUserActivity} from "../initialization/useGlobalUserActivity";
import {useInertiaNavigation} from "../initialization/useInertiaNavigation";
import {useLocationInitialization} from "../initialization/useLocationInitialization";
import {useResetSearchOnLeave} from "@/features/search";

type Props = {
    providerProps: ProviderProps;
};

export const AppInitialization = ({providerProps}: Props) => {
    /**
     * События и лоадер при навигации от инертии
     */
    useInertiaNavigation();

    /**
     * Определение местоположения по IP-Адресу (Через сервис DaData) и инициализация локации
     */
    useLocationInitialization(providerProps.location);

    /**
     * Добавляем слушатели на события пользователя
     */
    useGlobalUserActivity();

    /**
     * Обработка навигации по истории браузера
     */
    useBrowserHistoryNavigation();

    /**
     * Полный сброс поиска при уходе со страницы поиска
     */
    useResetSearchOnLeave();

    return null;
}
